import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { Box } from '@material-ui/core'

import { YandexMarketFilesTab } from '../../YandexMarketFilesTab'
import { YandexMarketLabelsPrintForm } from './YandexMarketLabelsPrint'
import { RouteTabSwitchItems, RoutingTabsSwitch } from '../../RoutingTabsSwitch'

import { useYmAccount } from '../../../hooks/routeHooks'

import { appRoutes, IntegrationRouteParams } from '../../../common/appRoutes'

export const YandexMarketPrintPage =
  observer(() => {
    const account = useYmAccount()

    const routes =
      useMemo(() => {
          const params: IntegrationRouteParams = {
            integration: 'YandexMarket',
            accountId: account.id
          }

          return [{
            title: 'Этикетки',
            template: appRoutes.Store.print.labels.template,
            path: appRoutes.Store.print.labels.makeUrl(params),
            render: () => <YandexMarketLabelsPrintForm/>
          }, {
            title: 'Файлы',
            template: appRoutes.Store.print.files.template,
            path: appRoutes.Store.print.files.makeUrl(params),
            render: () => <YandexMarketFilesTab/>
          }] as const satisfies RouteTabSwitchItems
        },
        [account])

    if (!account.isDeliveryFromSellerWarehouse) {
      return (
        <Box padding={3}>
          Печать этикеток недоступна при выбранной схеме работы.
        </Box>
      )
    }

    return <RoutingTabsSwitch routeTabs={routes}/>
  })